jQuery(document).ready(function ($) {
  var body = $("body"),
    doc = $(document),
    html = $("html"),
    win = $(window);
  var wishListsArr = localStorage.getItem("items") ? JSON.parse(localStorage.getItem("items")) : [];
  var compareArr = localStorage.getItem("compareArr") ? JSON.parse(localStorage.getItem("compareArr")) : [];

  localStorage.setItem("items", JSON.stringify(wishListsArr));
  if (wishListsArr.length) {
    wishListsArr = JSON.parse(localStorage.getItem("items"));
    jQuery('[data-total-wishlist]').html(wishListsArr.length);
  }
  var myOffcanvas = document.getElementById('lwc-sidecart');
  var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
         
  var lwc = {
    init: function () {
      this.main_menu();
      this.mobile_menu();
      this.mobile_tabs();
      this.getItems();
      this.wishlist();
      this.wishlisticons();
      this.ajax_pagination();
      this.set_page_items();
      this.removeitems();
    },
    main_menu: function () {
      $('a[href="#searchbar"]').on('click', function(e){
        e.preventDefault();
        $('.search_bar').slideDown();
      });
      $('.close_search_bar').on('click', function(){
        $('.search_bar').slideUp();
      });
      $(document.body).on('click', '.mobile_filter_icon', function(){
        $('#main-collection-filters').addClass('active');
        $('body').addClass('scrollfixed');
      });
      $('.filter_close').on('click', function(){
        $('#main-collection-filters').removeClass('active');
        $('body').removeClass('scrollfixed');
      });
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      $('.nav_menu.mobmenu li.hav_submenu span').on('click', function(e) {
         e.preventDefault();
          var t = $(this), ID = t.data('id'); 
          $(ID).addClass('active'); $('.mobile_menu .nav_menu').hide();$('.mega_menu').addClass('active');
      });
        $(document.body).on('click','#head_menu', function(){
          var t = $(this), ID = t.data('box'); 
          $(ID).removeClass('active');$('.mobile_menu .nav_menu').show();$('.mega_menu').removeClass('active');
        });
     }else{
      $(document).on('click', function(event) {
        // Check if the click was outside the box
        if (!$(event.target).closest('.menu_wrapper').length) {
          $('.menu_wrapper').removeClass('active'); // Remove the 'active' class
        }
    });
     $('#mega_hot-deals').on('mouseenter', function(e) {
         e.preventDefault();
          var t = $('#hot-deals');  $('#brands,#brands,#cigars,#accessories').removeClass('active');
            t.addClass('active').on('mouseleave', function(e) {
              $(this).removeClass('active');
          });
      });
     $('#mega_brands').on('mouseenter', function(e) {
         e.preventDefault();
          var t = $('#brands'); $('#hot-deals,#cigars,#accessories').removeClass('active');
          t.addClass('active').on('mouseleave', function(e) {
              $(this).removeClass('active');
          });
      });
     $('#mega_cigars').on('mouseenter', function(e) {
         e.preventDefault();
        var t = $('#cigars');  $('#hot-deals,#brands,#accessories').removeClass('active');
        t.addClass('active').on('mouseleave', function(e) {
          $(this).removeClass('active');
        });
      });
     $('#mega_accessories').on('mouseenter', function(e) {
         e.preventDefault();
          var t = $('#accessories');  $('#hot-deals,#brands,#cigars').removeClass('active');
          t.addClass('active').on('mouseleave', function(e) {
            $(this).removeClass('active');
          });
      });
      }
    },
    mobile_menu: function () {
      $("li.submenu a.alink").on("click", function (e) {
        e.preventDefault();
        var t = $(this);
        t.parent().toggleClass("open_dropdown");
        t.parent().find("ul").slideToggle();
        t.parent().siblings().removeClass("open_dropdown");
        t.parent().siblings().find("ul").slideUp();
      });
      $(".site_footer .ft-widget h3.toggle_menu").on("click", function () {
        var t = $(this);
        t.parent().toggleClass("active");
        t.next().slideToggle();
      });
    },
    mobile_tabs: function () {
      $('a[href="#pxaccount"]').on("click", function (e) {
        e.preventDefault();
        $("[data-user-mobile-toggle]").trigger("click");
      });
      $('a[href="#home"]').on("click", function (e) {
        e.preventDefault();
        $("html, body").animate(
          {
            scrollTop: jQuery("#shopify-section-header").offset().top,
          },
          1000
        );
        $('.lwc_search_bar input[type="search"]').focus();
      });
      $('a[href="#search"]').on("click", function (e) {
        e.preventDefault();
        $(".lwc_search_bar").slideToggle();
        $('.lwc_search_bar input[type="search"]').focus();
      });
    },
    getItems: function () {
      $.getJSON("/cart.json", function (e) {
        var total_cart_price = Shopify.formatMoney(e.total_price);
        $("[data-cartcount],a.menu-cart-icon span").text(e.item_count);
        if (e.item_count == 0) {
          $(".no-item-cart").show();
          $("form.cart-form.wrapper-template-cart").hide();
        } else {
          $(".no-item-cart").hide();
          $("form.cart-form.wrapper-template-cart").show();
        }
        if (e.item_count > 1) {
          $("[data-cartabre]").text("are");
        } else {
          $("[data-cartabre]").text("is");
        }
        $("#lwc-sidecart .total span.price,.cart_sumary .total span.price,[data-totalcart]").html(Shopify.formatMoney(e.total_price));
        if (e.items.length == 0) {
          $(".no-items").show();
          $(".actions").hide();
          $(".scrolling_items .summary").hide();
        } else {
          $(".no-items").hide();
          $(".actions").show();
          $(".scrolling_items .summary").show();
        }
        $('[data-toggle="tooltip"]').tooltip();
      });
      $.get("/cart?view=drawer", function (cartitems) {
        $("#cartdrawer").html(cartitems);
      });
      var sortby = $("a.dropdown-item.cactive").text();
      $("#tabletxt").text(sortby);
    },
    wishlist: function (ProductHandle) {
      var wishlistElm = $('[data-product-handle="' + ProductHandle + '"]'),
        idxArr = wishListsArr.indexOf(ProductHandle);
      $("#WishCounter").text(wishListsArr.length);
      jQuery('[data-total-wishlist]').html(wishListsArr.length);
      if (idxArr >= 0) {
        wishlistElm.addClass("active");
        wishlistElm
          .find(".wishlist-text")
          .text("window.inventory_text.remove_wishlist");
      } else {
        wishlistElm.removeClass("active");
        wishlistElm
          .find(".wishlist-text")
          .text("window.inventory_text.add_wishlist");
      }
      var iconWishListsSlt = "[data-icon-wishlist]";

      doc
        .off("click.addOrRemoveWishlist", iconWishListsSlt)
        .on("click.addOrRemoveWishlist", iconWishListsSlt, function (e) {
          e.preventDefault();

          var self = $(this),
            productId = self.data("did"),
            ProductHandle = self.data("product-handle"),
            idxArr = wishListsArr.indexOf(ProductHandle);

          if (!self.hasClass("active")) {
            self.addClass("active");
            self
              .find(".wishlist-text")
              .text("window.inventory_text.remove_wishlist");

            if ($("[data-wishlist-container]").length) {
              ella.createWishListTplItem(ProductHandle);
            }

            wishListsArr.push(ProductHandle);
            localStorage.setItem("items", JSON.stringify(wishListsArr));
          } else {
            self.removeClass("active").addClass('removedprod');
            $('[data-wishlist-added="wishlist-' + productId + '"]').remove();

            wishListsArr.splice(idxArr, 1);
            localStorage.setItem("items", JSON.stringify(wishListsArr));

            if ($("[data-wishlist-container]").length) {
            }
          }

          lwc.wishlist(ProductHandle);
        });
        
    },
    wishlisticons: function () {
      var wishListItems = JSON.parse(localStorage.getItem("items"));
      // var listitem = wishListItems.split(",");
      for (var i = 0; i < wishListItems.length; i++) {
        var icon = $('[data-product-handle="' + wishListItems[i] + '"]');
        icon.addClass("active");
        $.get(
          "/products/" + wishListItems[i] + "?view=wishlist",
          function (quick_response) {
            $("#lw_wishlist").append(quick_response);
          }
        );
      }
    },
    ajax_pagination: function () {
      var count = 1;
      $(document.body).on("click", ".px-infinite-scrolling a", function (e) {
        count++;
        e.preventDefault();
        $(this).append(' <div class="spinner-border spinner-border-sm"></div>');
        $.ajax({
          type: "get",
          url: $(this).data("href"),
          beforeSend: function () {},
          success: function (data) {
            var result = $(data)
              .find(".product-collection.fav_products ul, .blog_list ul")
              .html();
            var filterform = $(data).find(".filter-form").html();
            var pagebtn = $(data).find(".px-infinite-scrolling").html();
            $(".px-infinite-scrolling").html(pagebtn);
            $(".product-collection.fav_products ul, .blog_list ul").append(
              result
            );
            $("#filter-form").html(filterform);
            $(".js-range-slider").ionRangeSlider({
              onChange: function (rp) {
                $('input[name="filter.v.price.gte"]').val(rp.from);
                $('input[name="filter.v.price.lte"]').val(rp.to);
              },
              onFinish: function () {
                $("#filter-form").append(
                  '<input type="hidden" name="sort_by" value="price-ascending" />'
                );
                $("#filter-form").submit();
              },
            });
            $(".loading-modal").hide();
            $("div.col-sidebar .filter-group ul li").slice(0, 10).show();
            $("div.col-sidebar .filter-groups ul li").slice(0, 10).show();
            $("ul#filtter-health-ingredients li").slice(0, 10).show();
            $("ul#filtter-brand li").slice(0, 10).show();
          },
          error: function (xhr, text) {},
          complete: function () {
            var st = $("#filter-form"),
              sf = st.serialize();
            window.history.pushState("page2", "Title", "?" + sf);
          },
        });
      });
    },
    set_page_items: function () {
      $(document.body).on("click", "[data-setitemnumber] a", function (e) {
        e.preventDefault();
        var v = $(this).data("pnumber");
        $.ajax({
          type: "Post",
          url: "/cart.js",
          data: {
            "attributes[pagination]": v,
          },
          success: function (data) {
            window.location.reload();
          },
          error: function (xhr, text) {},
          dataType: "json",
        });
      });
    },
    removeitems: function () {
      $(document.body).on("click", "#remove-item", function () {
        var t = $(this);
        var id = t.data("id");
        $.ajax({
          type: "post",
          url: "/cart/change.js",
          data: "quantity=0&id=" + id,
          dataType: "json",
          success: function (cart) {
            jQuery(
              '[data-product-id="' + id + '"],[data-item-id="' + id + '"]'
            ).remove();
            lwc.getItems();
            lwc.coldPackRemove();
          },
          error: function (xhr) {},
        });
      });
    },
    coldPackRemove: function(){
       if(free_gift==true){
         jQuery.getJSON('/cart.js', function(cart){
          lwc.removeCartColdPack(cart);
         });
       }
    },
    removeCartColdPack: function(cart) {
      cart_total = cart.total_price / 100;
      if( cart_total < free_gift_amount ){
        var id = 0;
        var remove_cold_pack = true;
        for(var i = 0; i < cart.items.length; i++){
          if(cart.items[i].variant_id == free_gift_variant){
             var id = cart.items[i].id;
            var remove_cold_pack = false;
          }
        }
        if(remove_cold_pack == false){
          if(id > 0){
            jQuery.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=0&id=' + id,
                dataType: 'json',
                success: function() {
                   lwc.getItems();
                }
            });
          }
        }
      }
    },
    free_gift_by_ammount: function() {
     if(free_gift==true){
       jQuery.getJSON('/cart.js', function(cart){
    
        var free_gift_added = false;
        if(cart.item_count > 0) {
          for(var i = 0; i < cart.items.length; i++){
            if(cart.items[i].variant_id == free_gift_variant){
                 var free_gift_added = true;
            }
          }
        }
        if(free_gift_added==false){
          cart_total = cart.total_price / 100;
          if( cart_total > free_gift_amount ){
            lwc.free_gift_adding(cart);
            setTimeout(()=>{
               lwc.getItems(); 
             },1500);
          }
        } 
       });
     }
    },
    free_gift_by_tag: function() {
       if(free_gift==true){
         jQuery.getJSON('/cart.js', function(cart){
          lwc.free_gift_adding(cart);
         });
       }
    },
    free_gift_adding: function(cart) {
    var free_gift_added = false;
      if(cart.item_count > 0) {
        for(var i = 0; i < cart.items.length; i++){
          if(cart.items[i].variant_id == free_gift_variant){
               var free_gift_added = true;
          }
        }
      }
      if(free_gift_added==false){
        $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
             quantity: 1,
             id: free_gift_variant
           },
           dataType: 'json',
           success: function (data) {
             setTimeout(()=>{
               lwc.getItems();
             },1000);
           }
         });
      }
    }
  };
  lwc.init();
  $(document.body).on('change', '#boughtlist input', function(){
    var len = $('#boughtlist input:checked').length;
    if( len == 0 ){
      $('#addtcartone').prop('disabled', true);
    }else{
      $('#addtcartone').prop('disabled', false);  
    }
  });
  $(document.body).on('change', '#product_kit input', function(){
    var len = $('#product_kit input:checked').length;
    if( len == 0 ){
      $('#addtcarttwo').prop('disabled', true);
    }else{
      $('#addtcarttwo').prop('disabled', false);  
    }
  });
  $(document.body).on( "submit", '#add-to_cart,[data-type="add-to-cart-form"]', function (e) {
      e.preventDefault();
      var t = $(this);
      var data = t.serialize();
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          lwc.getItems();
           bsOffcanvas.show();
          
          if(free_gift==true){
           if(free_gift_type=='tag'){
             if(free_gift_status == true){
               lwc.free_gift_by_tag();
             }
           } else { 
             lwc.free_gift_by_ammount();
           }
            
          }
        },
      });
    }
  );
  const queryString = window.location.search;

  // Create a URLSearchParams object to easily work with the query string
  const urlParams = new URLSearchParams(queryString);

  // Check if the 'tab' parameter is equal to 'origin'
  if (urlParams.get('tab') === 'origin') {
    setTimeout(()=>{
      jQuery('[data-tab="#country-of-origin"]').trigger('click');
    },700);
    $('html, body').animate({
        scrollTop: $("#cigarsshop").offset().top
    }, 1000); 
  }
  if (urlParams.get('tab') === 'strength') {
    setTimeout(()=>{
      jQuery('[data-tab="#strength"]').trigger('click');
    },700);
    $('html, body').animate({
        scrollTop: $("#cigarsshop").offset().top
    }, 1000); 
  }
  $(document.body).on("click", "ul.tabs li", function () {
    var t = $(this),
      id = t.data("tab");
    t.addClass("active").siblings().removeClass("active");
    $(id).addClass("active").siblings().removeClass("active");
    $("[data-product-slider]").slick("setPosition");
  });

  var w = window.innerWidth;
  if( w < 992 ){
    $('[data-service_icons]').slick({
      dots: false,
      arrows:false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,autoplay:true
    });
    $('#banner_list').slick({
      dots: true,
      arrows:false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true
    });
  }
  $(document.body).on("click", "#addtocart", function (e) {
    var id = $(this).attr("data-id");
    e.preventDefault();
    datass = {
      id: id,
      quantity: 1,
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: datass,
      dataType: "json",
      success: function (cart) {
        lwc.getItems(); bsOffcanvas.show();
      },
    });
  });

  $(document.body).on("click", "[data-plus]", function (e) {
    e.preventDefault();
    var t = $(this),
      qty = t.siblings('input[type="number"]'),
      max_q = qty.data("max"),
      productId = qty.data("id"),
      q = parseInt(qty.val()) + 1;
    if (q < max_q || q == max_q) {
      qty.val(q);
      $.ajax({
        type: "post",
        url: "/cart/change.js",
        data: "quantity=" + q + "&id=" + productId,
        dataType: "json",
        success: function (cart) {
          lwc.getItems();
          if(free_gift==true){
           if(free_gift_type=='tag'){
             if(free_gift_status == true){
               lwc.free_gift_by_tag();
             }
           } else { 
             lwc.free_gift_by_ammount();
           }
           }
        },
        error: function (xhr) {},
      });
    }
    if (q > max_q) {
      $('[data-lmtqty="' + productId + '"]').html(
        '<div class="limited_qty"><i class="fa fa-info-circle"></i> Maximum quantity ' +
          max_q +
          "</div>"
      );
      setTimeout(function () {
        $('[data-lmtqty="' + productId + '"]').html("");
      }, 1500);
    }
  });
  $(document.body).on("click", "[data-minus]", function (e) {
    e.preventDefault();
    var t = $(this);
    let qty = t.siblings('input[type="number"]');
    let minus = parseInt(qty.val()) - 1;
    let productId = qty.data("id");
    if (minus > 0) {
      qty.val(minus);
      $.ajax({
        type: "post",
        url: "/cart/change.js",
        data: "quantity=" + minus + "&id=" + productId,
        dataType: "json",
        success: function (cart) {
          lwc.getItems();
          lwc.coldPackRemove();
        },
        error: function (xhr) {},
      });
    }
  });
  $("[data-product-slider]").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    // prevArrow: '<span class="lft"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/circle-slider-arr.png?v=1737030815" /></span>',
    // nextArrow: '<span class="ryt"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/circle-slider-arr.png?v=1737030815" /></span>',
    prevArrow: '<span class="lft"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/slide-arrow.png?v=1736173092" /></span>',
    nextArrow: '<span class="ryt"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/slide-arrow.png?v=1736173092" /></span>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  
  $("[data-category-slider]").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<span class="lft"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/circle-slider-arr.png?v=1737030815" /></span>',
    nextArrow: '<span class="ryt"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/circle-slider-arr.png?v=1737030815" /></span>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".brand_list").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1, dots: true,
          variableWidth: true,
          arrows:false,infinite: true
        },
      },
    ],
  });
  $("[data-history-slider]").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<span class="lft"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/circle-slider-arr.png?v=1737030815" /></span>',
    nextArrow: '<span class="ryt"><img src="https://cdn.shopify.com/s/files/1/0420/9351/0809/files/circle-slider-arr.png?v=1737030815" /></span>',
  });
  $(".top_slider").slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<span class="lft"><svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L2 12.6667L17 22" stroke="white" stroke-width="2"/></svg></span>',
    nextArrow: '<span class="ryt"><svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L2 12.6667L17 22" stroke="white" stroke-width="2"/></svg></span>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,autoplay:true,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 2,
          autoplay:true,
        },
      },
    ],
  });
  
  $('#annoucementbar').slick({
    dots: false,
    arrows:false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    autoplay: true,
  });
  $('#as_seen').slick({
    dots: false,
    arrows:false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    centerMode: true,
    variableWidth: true,autoplaySpeed: 100, // Set to 0 for continuous scrolling
    cssEase: 'linear',
  });
  $('a[href="#readmore"]').on('click', function(e){ e.preventDefault();
    $('html, body').animate({
        scrollTop: jQuery("#lw_desc").offset().top
    }, 1000); 
  });
});